// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__aOBb1","galaxyTilesWrapper":"Tile_galaxyTilesWrapper__AI9gL","point":"Tile_point__Gu9F2","diamond":"Tile_diamond__jQJ+J","halo":"Tile_halo__zYlZe"};